import * as React from 'react';

import { useHistory } from 'react-router-dom';

import { updateBaseURL, updateUserAgent } from 'api/services/entity';
import { useAppDispatch, useAppSelector } from 'app';
import {
  selectAccount,
  selectAppDevice,
  selectAppState,
  selectOneAccount,
} from 'slice';
import { SELECTED_ENTITY } from 'types/localStorage';
import {
  getCurrentTabIndex,
  getUserInfoComputer,
  handleRedirectSignIn,
  removeVietnameseTones,
} from 'utils';

const WithSelected = WrappedComponent =>
  function HOC(props) {
    const history = useHistory();
    const dispatch = useAppDispatch();
    const app = useAppSelector(selectAppState);
    const appDevice = useAppSelector(selectAppDevice);

    const account = useAppSelector(selectAccount);

    React.useEffect(() => {
      const browserInfo = getUserInfoComputer();
      const indexTab = getCurrentTabIndex();
      if (account?.item?.id) {
        const content = `[${removeVietnameseTones(
          account?.item?.displayName || 'NoName'
        )}] [${browserInfo}] [${indexTab}] [HUB-ADMIN]`;
        updateUserAgent(content);
      } else {
        const content = `[AnonymousUser] [${browserInfo}] [${indexTab}] [HUB-ADMIN]`;
        updateUserAgent(content);
      }
    }, [account?.item?.id]);

    React.useEffect(() => {
      if (window.location.host.includes('open.local')) {
        updateBaseURL('http://localhost:4004/api/v1');
      }
    }, []);

    React.useEffect(() => {
      const handleFindEntity = async () => {
        try {
          const selectedEntity = localStorage.getItem(SELECTED_ENTITY);

          if (!selectedEntity) {
            history.push('/account/list');
            return;
          }
          const { id } = JSON.parse(selectedEntity as string);

          await dispatch(selectOneAccount(id)).unwrap();
        } catch (error) {
          handleRedirectSignIn(
            history,
            '/sign-in',
            appDevice.isSpecificBrowser,
            app?.domains?.hubIdentity?.domain
          );
        }
      };

      if (account.isFirstSelected == false) {
        handleFindEntity();
      }
    }, [history, dispatch]);

    return <>{account?.item ? <WrappedComponent {...props} /> : null}</>;
  };

export default WithSelected;
